import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-funcionalidade-desabilitada',
    templateUrl: './funcionalidade-desabilitada.component.html',
    styleUrls: ['./funcionalidade-desabilitada.component.scss'],
    standalone: false
})
export class FuncionalidadeDesabilitadaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
